
import axios from 'axios';
import configrations from '../config/configrations';
const API_URL = `${configrations.backendBaseUrl}`;

// ======================== ADMIN DASHBOARD RELATED SERVICES ======================== 
// Staff related services

export const createStaff = (data) => {
  const token = localStorage.getItem('token');
  return axios.post(`${API_URL}/admin/staffs`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json' 
    }
  });
};

export const getAllStaffs = () => {
  const token = localStorage.getItem('token');
  
  return axios.get(`${API_URL}/admin/staffs`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const getStaffById = (id) => {
  const token = localStorage.getItem('token');
  
  return axios.get(`${API_URL}/admin/staffs/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
};


// Update Permissions (Calls updateStaffProfile in backend)
export const updateStaffPermission = (id, permissions = {}) => {
  const token = localStorage.getItem('token');
  return axios.put(`${API_URL}/admin/staffs/${id}`, 
    { permissions }, // Wrap in object
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

// Update Status (Calls updateStaffStatus in backend)
export const updateStaffStatus = (id, isActive) => {
  const token = localStorage.getItem('token');
  return axios.patch(`${API_URL}/admin/staffs/${id}/status`, 
    { isActive }, // Wrap in object to match const { isActive } = req.body
    { headers: { Authorization: `Bearer ${token}` } }
  );
};


// Customer related services 

export const createUser = (formDataToSend) => {
  const token = localStorage.getItem('token');  // Get the token from localStorage

  return axios.post(`${API_URL}/admin/users`, formDataToSend, {
    headers: {
      Authorization: `Bearer ${token}`,  // Attach token for Authorization
      'Content-Type': 'multipart/form-data',  // Ensure content type for file upload
    },
    withCredentials: true  // Important to allow cookies or credentials with the request
  });
};

export const getUsers = () => {
  const token = localStorage.getItem('token');
  
  return axios.get(`${API_URL}/admin/users`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

export const getUserDetailsById = (userId) => {
  const token = localStorage.getItem('token');
  
  return axios.get(`${API_URL}/admin/users/${userId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
};

export const updateUser = (userId, formData) => {
  const token = localStorage.getItem('token');

  return axios.put(
    `${API_URL}/admin/users/${userId}`,
    formData,   // ✅ actual data here
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// Get user details by account number
export const getUserByAccountNumber = (accountNumber) => {
  const token = localStorage.getItem('token');

  // return axios.get(`${API_URL}/users/${accountNumber}`, {
  return axios.get(`${API_URL}/admin/users/account/${accountNumber}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};



// Transactions related services 
  
export const updateAmount = (accountNumber, data) => {
  const token = localStorage.getItem('token');
  
  return axios.post(`${API_URL}/admin/transactions/${accountNumber}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }  
  );
};

// Get all transactions of a specific user (passbook)
export const getTransactionsByUserAccountNumber = (accountNumber) => {
  const token = localStorage.getItem('token');
  // return axios.get(`${API_URL}/users/${accountNumber}/transactions`, {
  return axios.get(`${API_URL}/admin/transactions/user/${accountNumber}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export const getTodaysTransactions = () => {
  const token = localStorage.getItem('token');
  // return axios.get(`${API_URL}/users/transactions/today`, {
  return axios.get(`${API_URL}/admin/transactions/today`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

export const getAllTransactions = () => {
  const token = localStorage.getItem('token');
  return axios.get(`${API_URL}/admin/transactions`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};


export const getStaffTransactions = (params = {}) => {
  const token = localStorage.getItem("token");

  return axios.get(
    `${API_URL}/admin/transactions/staff-wise`,
    {
      params, // ✅ correct way
      headers: { Authorization: `Bearer ${token}` }
    }
  );
};

// ========================= STAFF DASHBOARD APIS =========================
export const getMyTransactions = () => {
  return axios.get(`${API_URL}/staff/transactions`);
};


// ============================= CONTACT US PAGE RELATED SERVICES  =============================

// ContactUs related services 

export const getAllQueries = () => {
  const token = localStorage.getItem('token');
  return axios.get(`${API_URL}/admin/queries`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
};

export const deleteQuery = (id) => {
  const token = localStorage.getItem('token');
  return axios.delete(`${API_URL}/admin/queries/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};


